import { SET_SUPPLIERS, SET_SUPPLIERS_DATA_LOADING, SET_SEARCH_SUPPLIER_BY_ID } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';
import { SET_CATEGORY_DATA_LOADING } from '../../categories/actions/types';

export const getSuppliers = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_SUPPLIERS_DATA_LOADING });
    const companyId = store.getState().authState.companyId;

    const queryParams = {
      ...params,
      companyId,
    };

    const res = await Axios.get(`/api/dashboard/suppliers/find-all`, {
      params: queryParams,
    });

    dispatch({
      type: SET_SUPPLIERS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: SET_SUPPLIERS,
      payload: [],
    });
  }
};

export const createSupplier = (supplier) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SUPPLIERS_DATA_LOADING,
      payload: true,
    });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const requestBody = {
      ...supplier,
      companyId,
    }

    const queryParams = {
      companyId,
      branchId,
    }

    const res = await Axios.post(`/api/dashboard/suppliers`, requestBody, {
      params: queryParams
    });

    dispatch({
      type: SET_SUPPLIERS_DATA_LOADING,
      payload: false,
    })
    return true;
  } catch (error) {
    return false;
  }
};

export const updateSupplier = (id, requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SUPPLIERS_DATA_LOADING,
      payload: true,
    });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.put(`/api/dashboard/suppliers/${id}`, { id, ...requestBody }, {
      params: queryParams,
    });

    dispatch({
      type: SET_CATEGORY_DATA_LOADING,
      payload: false,
    });

    return true;
  } catch (error) {
    return false;
  }
};

export const getSupplierById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SUPPLIERS_DATA_LOADING,
      payload: true,
    })

    const res = await Axios.get(`/api/dashboard/suppliers/find-by-id`, {
      params: { id },
    });

    dispatch({
      type: SET_SEARCH_SUPPLIER_BY_ID,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: SET_SEARCH_SUPPLIER_BY_ID,
      payload: [],
    });
  }
};